const funcion7 = {
    titulo: `Función: retorno de un objeto`,
    problemas: [
      {
        codigo:1,
        descripcion: `Una función puede retornar un objeto, recordemos que un Array es un tipo especial de objeto y puede ser retornado.`,
programa: `function retornarPersona() {
  const persona = {
    nombre: 'Juan',
    apellido: 'Perez',
    edad: 20
  }
  return persona
}

const persona1 = retornarPersona()
console.log(persona1)`,
        solucion: "{nombre: 'Juan', apellido: 'Perez', edad: 20}"
      },{
        codigo:2,
        descripcion: ``,
programa: `function crearArticulo(codigo, descripcion, precio) {
  const articulo = {
    codigo: codigo,
    descripcion: descripcion,
    precio: precio
  }
  return articulo
}

const articulo1 = crearArticulo(1, "Naranjas", 150)
console.log(articulo1)`,
        solucion: "{codigo: 1, descripcion: 'Naranjas', precio: 150}"
      },{
        codigo:3,
        descripcion: `Actualmente la sintaxis más concisa del problema anterior se codifica:`,
programa: `function crearArticulo(codigo, descripcion, precio) {
    const articulo = {
      codigo,
      descripcion,
      precio
    }
    return articulo
  }

  const articulo1 = crearArticulo(1, "Naranjas", 150)
  console.log(articulo1)`,
        solucion: "{codigo: 1, descripcion: 'Naranjas', precio: 150}"
      },{
        codigo:4,
        descripcion: ``,
programa: `function retornarCoordenada() {
    return {
      x: 10,
      y: 20
    }
  }

  console.log(retornarCoordenada())`,
        solucion: "{x: 10, y: 20}"
      }
    ]
  }

export default funcion7;